import * as React from 'react';

import { getCrowdinThemeMode, subscribeCrowdinTheme } from '@/lib/crowdin-host';

// Tracks the Crowdin host theme mode and keeps the host palette applied. Every React
// root on the page reads the same store, so a page with more than one root cannot end
// up with two disagreeing themes. Outside the Crowdin iframe it stays on 'light' -
// wire your own standalone theming (e.g. next-themes) off the returned value.
export function useCrowdinTheme() {
    return React.useSyncExternalStore(subscribeCrowdinTheme, getCrowdinThemeMode, getCrowdinThemeMode);
}
